export const FormatDate = (dateString) => {
    if (!dateString) {
        return '---'; // Message for empty date string
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return 'Invalid date'; // Message for invalid date
    }
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options); // Adjust locale as needed
};